import { render, staticRenderFns } from "./UserDashboardTabsFollows.vue?vue&type=template&id=6c329042&scoped=true&"
import script from "./UserDashboardTabsFollows.vue?vue&type=script&lang=js&"
export * from "./UserDashboardTabsFollows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c329042",
  null
  
)

export default component.exports